<template>
	<q-layout :view="getView">
		<etraining-header />

		<menu-left />

		<q-page-container>
			<etraining-navbar />

            <accept-terms/>

			<router-view :style="themeStyles" />
		</q-page-container>

		<menu-right />

		<etraining-footer />

		<floating-player />

		<player />
  	</q-layout>
</template>

<script>
import Header from 'components/authenticated/Header'
import Footer from 'components/authenticated/Footer'
import Navbar from 'components/authenticated/Navbar'
import MenuLeft from 'components/authenticated/MenuLeft'
import MenuRight from 'components/authenticated/MenuRight'
import FloatingPlayer from 'components/podcasts/FloatingPlayer'
import Player from 'components/podcasts/Player'
import AcceptTerms from 'components/authenticated/AcceptTerms'
import { colors } from 'quasar'
import { mapGetters } from 'vuex'

export default {
	components: {
		'etraining-header': Header,
		'etraining-footer': Footer,
		'etraining-navbar': Navbar,
		'menu-left': MenuLeft,
		'menu-right': MenuRight,
		'floating-player': FloatingPlayer,
		'player': Player,
		'accept-terms': AcceptTerms,
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
			full_name: 'common/full_name',
			email: 'common/email',
			zendesk_help: 'params/login_zendesk_help'
		}),

		getView() {
			if (this.$q.platform.is.mobile) return 'hHh Lpr lFf'
			else return 'hHh Lpr fff'
		},

		themeStyles () {
			let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
				if (client.use_background) {
					return {
						marginTop: '1px',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
						backgroundSize: 'cover',
						backgroundImage: `url(${client.full_background})`
					}
				}
				else return ''
			}
		}
	},

	methods: {
		changeColor() {
			let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
			if (client) {
				colors.setBrand('primary', client.colors.primary)
				colors.setBrand('secondary', client.colors.secondary)
				colors.setBrand('tertiary', client.colors.tertiary)
			}
		}
	},

	watch: {
		params_loaded: function() {
			this.changeColor()
		},

		id_user_client_selected: function() {
			this.changeColor()
        }
	},

	created() {
		if (this.clients) {
			this.changeColor()
		}

		if (this.zendesk_help) {
			this.$zendesk.load(process.env.ZENDESK_KEY)

			this.$zendesk.$on('loaded', (event) => {
				this.$zendesk.show()

				window.zESettings = {
					webWidget: {
						color: {
							theme: '#000'
						},
						offset: {
							horizontal: '10px',
							vertical: '10px',
							mobile: {
								horizontal: '10px',
								vertical: '50px'
							}
						},
						position: { horizontal: 'right', vertical: 'bottom' },
						zIndex: 999999,
						contactForm: {
							fields: [
								{ id: 'name', prefill: { '*': this.full_name } },
								{ id: 'email', prefill: { '*': this.email } }
							]
						}
					}
				}

				
			})
		}	
	}
}
</script>

<style>
</style>
